{
  "playerRadius": 14,
  "talentChoices": 3,
  "abilityMaxRank": 5,
  "gemMagnetSpeed": 420,
  "physics": {
    "playerAccel": 2400,
    "playerDecel": 2000,
    "knockbackDamping": 10,
    "staggerRatio": 1,
    "separation": 1.6,
    "lootScatter": [
      45,
      90
    ],
    "lootFriction": 7,
    "magnetStartSpeed": 120,
    "magnetAccel": 1400,
    "playerShotsHitObstacles": false,
    "hostileShotsHitObstacles": false,
    "personalSpace": 1.15,
    "crowdCorrection": 0.3,
    "maxKnockbackSpeed": 540
  },
  "enemyHealthScalingPerMinute": 0.35,
  "xp": {
    "base": 5,
    "growth": 1.18
  },
  "spawn": {
    "baseInterval": 1.2,
    "minInterval": 0.3,
    "rampSeconds": 480,
    "groupGrowthSeconds": 75,
    "ringDistance": 520,
    "maxEnemies": 150
  },
  "loot": {
    "goldDropChance": 0.22,
    "potionDropChance": 0.012,
    "itemDropChance": 0.012,
    "eliteItemChance": 0.5,
    "eliteRadius": 20,
    "potionHeal": 0.3,
    "firstChest": 15,
    "chestInterval": 40,
    "maxChests": 3,
    "chestDistance": [
      280,
      420
    ],
    "chestDespawnDistance": 1400,
    "chestCoins": [
      6,
      10
    ],
    "chestItemChance": 0.8,
    "chestPotionChance": 0.35,
    "upgradeCost": 120
  },
  "gacha": {
    "pullCost": 100,
    "pityEpic": 10,
    "pityLegendary": 60,
    "maxLevel": 5,
    "levelBonus": 0.15,
    "startingCurrency": 1000,
    "currencyPerKill": 1,
    "currencyPerMinute": 20,
    "shardsPerDuplicate": {
      "zwykly": 1,
      "rzadki": 3,
      "epicki": 10,
      "legendarny": 40
    },
    "shardUpgradeCost": 6
  },
  "power": {
    "penaltyPerMissing": 0.6,
    "maxPenalty": 0.5
  },
  "runEvents": {
    "first": 75,
    "interval": [
      95,
      135
    ],
    "list": [
      {
        "id": "mgla",
        "name": "Mgła nadciąga",
        "description": "Gęsta mgła kładzie się na ziemi. Widać tylko najbliższą okolicę.",
        "kind": "fog",
        "duration": 25
      },
      {
        "id": "przekleta-skrzynia",
        "name": "Przeklęta skrzynia",
        "description": "Gdzieś w pobliżu stoi skrzynia strzeżona przez kościaną straż.",
        "kind": "cursedChest",
        "duration": 30,
        "guards": 8
      },
      {
        "id": "krwawy-ksiezyc",
        "name": "Krwawy księżyc",
        "description": "Umarli wstają szybciej. Więcej wrogów, więcej doświadczenia.",
        "kind": "frenzy",
        "duration": 20,
        "spawnBoost": 0.5
      }
    ]
  }
}
